module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/registry-desktop@2x-54954b761f2481f239510e93d1e48935.jpg";